export default "__VITE_ASSET__DuvJ7suA__"